import {
  Grid2 as Grid,
  Typography,
  Divider,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { FC } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { addressTitles } from "src/shared/constants/address.constants";
import { addressDefaultValue } from "../../model/constants";
import { IPartnerFormValues } from "../../model/types";
import { AddressBlockItem } from "./AddressBlockItem";

export const AddressBlock: FC = () => {
  const { watch, control } = useFormContext<IPartnerFormValues>();
  const {
    fields: addressesFields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "addresses",
  });

  const additionalAddressIndex = addressesFields.findIndex(
    (address) => address.type === "postal_additional",
  );

  const postalAddressIndex = addressesFields.findIndex(
    (address) => address.type === "postal",
  );

  const isPostAddressTheSame = watch("isPostAddressTheSame");
  const isAdditionalAddressOn = watch("isAdditionalAddressOn");

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Divider />
      </Grid>
      <Grid size={12}>
        <Typography
          sx={{
            color: "grey.500",
            fontSize: "0.875rem",
          }}
        >
          {addressTitles.legal}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, lg: 8 }}>
        <AddressBlockItem
          names={{
            country: "addresses.0.country_id",
            address: "addresses.0.address",
            area: "addresses.0.area",
            region: "addresses.0.region",
            postcode: "addresses.0.postcode",
            city: "addresses.0.city",
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 4 }}>
        <Controller
          control={control}
          name="isPostAddressTheSame"
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  onChange={(e) => {
                    if (!e.target.checked && postalAddressIndex < 0) {
                      append({
                        ...addressDefaultValue,
                        type: "postal",
                      });
                    } else {
                      remove(postalAddressIndex);
                    }
                    field.onChange(e);
                  }}
                  checked={!!field.value}
                />
              }
              label="Почтовый адрес совпадает с юридическим"
            />
          )}
        />
      </Grid>
      {postalAddressIndex > 0 && !isPostAddressTheSame && (
        <>
          <Grid size={12}>
            <Divider />
          </Grid>
          <Grid size={12}>
            <Typography
              sx={{
                color: "grey.500",
                fontSize: "0.875rem",
              }}
            >
              {addressTitles.postal}
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, lg: 8 }}
            key={addressesFields[postalAddressIndex].id}
          >
            <AddressBlockItem
              names={{
                country: `addresses.${postalAddressIndex}.country_id`,
                address: `addresses.${postalAddressIndex}.address`,
                area: `addresses.${postalAddressIndex}.area`,
                region: `addresses.${postalAddressIndex}.region`,
                postcode: `addresses.${postalAddressIndex}.postcode`,
                city: `addresses.${postalAddressIndex}.city`,
              }}
            />
          </Grid>
        </>
      )}
      <Grid size={12}>
        <Controller
          control={control}
          name="isAdditionalAddressOn"
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  onChange={(e) => {
                    if (e.target.checked && additionalAddressIndex < 0) {
                      append({
                        ...addressDefaultValue,
                        type: "postal_additional",
                      });
                    } else {
                      remove(additionalAddressIndex);
                    }
                    field.onChange(e);
                  }}
                  checked={!!field.value}
                />
              }
              label={addressTitles.postal_additional}
            />
          )}
        />
      </Grid>
      {additionalAddressIndex > 0 && isAdditionalAddressOn && (
        <Grid
          size={{ xs: 12, lg: 8 }}
          key={addressesFields[additionalAddressIndex].id}
        >
          <AddressBlockItem
            names={{
              address: `addresses.${additionalAddressIndex}.address`,
              area: `addresses.${additionalAddressIndex}.area`,
              region: `addresses.${additionalAddressIndex}.region`,
              postcode: `addresses.${additionalAddressIndex}.postcode`,
              city: `addresses.${additionalAddressIndex}.city`,
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};
